<div class="ui-table-transfer">
  <div class="ui-table-transfer__table">
    <div class="ui-table-transfer__heading">
      <strong>{{ leftTitle() }}</strong>
      <span>{{ leftSubtitle() }}</span>
    </div>
    <ui-data-table
      [style.--ui-dt-host-h]="tableHostHeight()"
      [columns]="leftColumns()"
      [rows]="leftViewRows()"
      [total]="leftViewRows().length"
      [pageSize]="pageSize()"
      [rowKey]="rowKey()"
      [selectable]="true"
      [(selectedKeys)]="leftSelectedKeys"
      [showExcel]="false"
      [showNewButton]="false"
      [showStatusFilter]="false"
      [showActionsColumn]="false"
      [showColumnFilters]="showColumnFilters()"
      [sortingEnabled]="sortingEnabled()"
      [showPagination]="showPagination()"
      [showPageSize]="showPageSize()"
      [columnSizing]="columnSizing()"
      [verticalScroll]="verticalScroll()"
      (columnFiltersChange)="onFilters('left', $event)"
      (sortChange)="onSort('left', $event)"
    />
  </div>

  <div class="ui-table-transfer__actions" aria-label="Acciones de transferencia">
    <ui-button
      variant="secondary"
      size="sm"
      ariaLabel="Transferir seleccionados a la derecha"
      [disabled]="!canMoveSelectedRight()"
      (pressed)="moveSelected('to-right')"
    >
      &gt;
    </ui-button>
    <ui-button
      variant="secondary"
      size="sm"
      ariaLabel="Transferir todos los visibles a la derecha"
      [disabled]="!canMoveAllRight()"
      (pressed)="moveAll('to-right')"
    >
      &gt;&gt;
    </ui-button>
    <ui-button
      variant="secondary"
      size="sm"
      ariaLabel="Transferir seleccionados a la izquierda"
      [disabled]="!canMoveSelectedLeft()"
      (pressed)="moveSelected('to-left')"
    >
      &lt;
    </ui-button>
    <ui-button
      variant="secondary"
      size="sm"
      ariaLabel="Transferir todos los visibles a la izquierda"
      [disabled]="!canMoveAllLeft()"
      (pressed)="moveAll('to-left')"
    >
      &lt;&lt;
    </ui-button>
  </div>

  <div class="ui-table-transfer__table">
    <div class="ui-table-transfer__heading">
      <strong>{{ rightTitle() }}</strong>
      <span>{{ rightSubtitle() }}</span>
    </div>
    <ui-data-table
      [style.--ui-dt-host-h]="tableHostHeight()"
      [columns]="effectiveRightColumns()"
      [rows]="rightViewRows()"
      [total]="rightViewRows().length"
      [pageSize]="pageSize()"
      [rowKey]="rowKey()"
      [selectable]="true"
      [(selectedKeys)]="rightSelectedKeys"
      [showExcel]="false"
      [showNewButton]="false"
      [showStatusFilter]="false"
      [showActionsColumn]="false"
      [showColumnFilters]="showColumnFilters()"
      [sortingEnabled]="sortingEnabled()"
      [showPagination]="showPagination()"
      [showPageSize]="showPageSize()"
      [columnSizing]="columnSizing()"
      [verticalScroll]="verticalScroll()"
      (columnFiltersChange)="onFilters('right', $event)"
      (sortChange)="onSort('right', $event)"
    />
  </div>
</div>
